import customNav from './customNav.js';
import {
  isPage,
  cleanContent,
  moveWidgetsToMainContent,
  logosURL,
  applyFairThemeFavicon,
} from './helpers.js';
import initFairWidgets from './subtheme/initFairWidgets.js';

export function themeController(themeData) {
  // CUSTOM NAV
  customNav(themeData);

  // HEADER LOGO URL
  logosURL(themeData);

  if (isPage('douglas-county-fair')) {
    initFairWidgets();
    applyFairThemeFavicon();
  }

  if (isPage('douglas-county-fair-home')) {
    $(globalThis).load(function () {
      $('#goog-gt-tt').remove();
    });
    cleanContent();
    moveWidgetsToMainContent(themeData);
  }
}
